import React from "react";
import { Container, Row, Col, Card, Button, ListGroup } from "react-bootstrap";

const CartPage = ({ cart, onRemove, onProceedToCheckout, onContinueShopping }) => {
  const subtotal = cart.reduce((sum, item) => sum + item.price, 0);
  const gst = subtotal * 0.10;
  const total = subtotal + gst;

  return (
    <Container className="py-5">
      <h1 className="text-center mb-4" style={{ color: "#2959A5" }}>Your Cart</h1>

      <p className="text-center text-muted mb-5">
        You are almost ready to power your events with <span style={{ color: "#EF3E6D", fontWeight: "600" }}>Where The Truck</span> tokens.
      </p>

      {cart.length === 0 ? (
        <p className="text-center">Your cart is empty. Go back and add some token packs!</p>
      ) : (
        <>
          <ListGroup className="mb-4 shadow-sm">
            {cart.map((item, idx) => (
              <ListGroup.Item key={idx} className="d-flex justify-content-between align-items-center">
                <div>
                  <h5 className="mb-1" style={{ color: "#2959A5" }}>{item.name}</h5>
                  <small className="text-muted">{item.tokens} Tokens</small>
                  <p className="mb-0 fw-bold" style={{ color: "#EF3E6D" }}>${item.price.toFixed(2)}</p>
                </div>
                <Button
                  variant="outline-danger"
                  size="sm"
                  className="rounded-pill fw-semibold"
                  onClick={() => onRemove(idx)}
                >
                  Remove
                </Button>
              </ListGroup.Item>
            ))}
          </ListGroup>

          <Card className="text-center p-4 shadow-sm mb-4">
            <Row className="mb-2">
              <Col className="text-start">Subtotal:</Col>
              <Col className="text-end">${subtotal.toFixed(2)}</Col>
            </Row>
            <Row className="mb-2">
              <Col className="text-start">GST (10%):</Col>
              <Col className="text-end">${gst.toFixed(2)}</Col>
            </Row>
            <hr />
            <Row className="mb-3">
              <Col className="text-start fw-bold">Total:</Col>
              <Col className="text-end fw-bold" style={{ color: "#EF3E6D" }}>${total.toFixed(2)}</Col>
            </Row>
            <div className="d-flex justify-content-center gap-3">
              <Button
                variant="outline-secondary"
                className="rounded-pill fw-semibold"
                onClick={onContinueShopping}
              >
                Continue Shopping
              </Button>
              <Button
                variant="danger"
                className="rounded-pill fw-semibold px-4"
                style={{ backgroundColor: "#EF3E6D", borderColor: "#EF3E6D" }}
                onClick={onProceedToCheckout}
              >
                Proceed to Checkout
              </Button>
            </div>
          </Card>

          <p className="text-center text-muted" style={{ fontSize: "0.9rem" }}>
            All prices are in AUD. GST included in total.
          </p>
        </>
      )}
    </Container>
  );
};

export default CartPage;
